//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Amount
import com.tixforgigs.apax.models.Invoice
import com.tixforgigs.apax.models.OrderState
import com.tixforgigs.apax.models.OrderTypeId
import com.tixforgigs.apax.models.Payment
import com.tixforgigs.apax.models.TicketLinks

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The ticket order model
* 
* @param id The order id
* @param orderDate The order date
* @param state 
* @param subTotal 
* @param token The order token
* @param type 
* @param invoices List of invoices associated with the order
* @param links 
* @param payment 
*/
@Serializable

data class TicketOrder (


      /* The order id */
    @SerialName(value = "id") @Required val id: kotlin.Int,


      /* The order date */
    @SerialName(value = "orderDate") @Required val orderDate: kotlin.time.Instant,


      @SerialName(value = "state") @Required val state: OrderState,


      @SerialName(value = "subTotal") @Required val subTotal: Amount,


      /* The order token */
    @SerialName(value = "token") @Required val token: kotlin.String,


      @SerialName(value = "type") @Required val type: OrderTypeId,


      /* List of invoices associated with the order */
    @SerialName(value = "invoices") val invoices: kotlin.collections.List<Invoice>? = null,


      @SerialName(value = "links") val links: TicketLinks? = null,


      @SerialName(value = "payment") val payment: Payment? = null


) {




  }

